import { DEFAULT_PAGE_SIZE } from "../constants";

export interface IEndlessRange {
    startIndex: number;
    endIndex: number;
}

export class EndlessRangeManager {
    syncPageSize(isEndlessScrollEnabled: boolean, dataSource: any): number {
        if (!isEndlessScrollEnabled || !dataSource || typeof dataSource.pageSize !== "function") {
            return DEFAULT_PAGE_SIZE;
        }

        let pageSize = Number(dataSource.pageSize());

        if (!Number.isFinite(pageSize) || pageSize < 1) {
            pageSize = DEFAULT_PAGE_SIZE;
            dataSource.pageSize(pageSize);
        }

        return Math.max(1, pageSize);
    }

    getLatestRange(pageSize: number, totalCount: number): IEndlessRange {
        const endIndex = totalCount;
        const startIndex = Math.max(0, endIndex - pageSize);

        return { startIndex, endIndex };
    }

    getTargetRange(targetIndex: number, pageSize: number, totalCount: number): IEndlessRange {
        if (totalCount <= pageSize) {
            return {
                startIndex: 0,
                endIndex: totalCount
            };
        }

        let startIndex = Math.max(0, targetIndex - Math.floor(pageSize / 2));
        let endIndex = Math.min(totalCount, startIndex + pageSize);

        startIndex = Math.max(0, endIndex - pageSize);

        return { startIndex, endIndex };
    }

    isLatestRenderedRange(renderEndIndex: number, totalCount: number): boolean {
        return renderEndIndex === totalCount;
    }

    hasRenderedLatestMessage(renderEndIndex: number, totalCount: number): boolean {
        return this.isLatestRenderedRange(renderEndIndex, totalCount);
    }
}